
$(document).on('click','.label-list button' , function(){
	$(this).parents('.label-list').find('.label-inner').toggleClass("imp");
});

var writeReview = null;
const $obj = $('.GPC0026.plp');
const $target = document.querySelector('.GPC0026.plp');
$(document).ready(function() {
	var objModel_ui = function() {
		$(window).on('scroll' ,function(){
			if ($(window).width() < 767){
				$('.label-inner').each( function(i){
					var srlTop = $(window).scrollTop();
					var winH = $(window).innerHeight();
					var harf_pos = winH / 2;
					var obj_pos = $(this).offset().top + harf_pos;
					if( srlTop + winH > obj_pos ){
						$(this).addClass("act");
						$(this).removeClass("imp");
						$(this).parent('.label-list').find('button').attr('disabled', true);
					}  else{
						$(this).removeClass("act");
						$(this).parent('.label-list').find('button').attr('disabled', false);
					}
				});
			} 
		});
	}
	var listBox_resize = function() {
		var $item_width = $('.list-box').find('li > .item').outerWidth();
			if ($(window).width() < 767 || isMobile){
			$('.pd-share').find('.list').addClass('mobileSns');
		} else{
			$('.pd-share').find('.list').css('width', $item_width);
			$('.pd-share').find('.list').removeClass('mobileSns');
		}
	}

	$('.btn-listChange').on('click' ,function(){
		$('.btn-listChange').toggleClass("act");
		if($('.btn-listChange').hasClass('act')){
			$(".product-list-box").addClass('rows');
			$('.btn-listChange').attr("data-sc-item", "plp_btn_list_change_to_2");
		}else{
			$(".product-list-box").removeClass('rows');
			$('.btn-listChange').attr("data-sc-item", "plp_btn_list_change_to_1");
		};
		if($('.thumbnail-carousel').hasClass('slick-initialized')){
			$('.thumbnail-carousel').slick('unslick');
			$('.thumbnail-carousel').slick({
				arrows: false,
				dots: true
			});
		} else{
			$('.thumbnail-carousel').slick({
				arrows: false,
				dots: true
			});
		}
		objModel_ui();
	});

	$(window).on('load resize', function() {
		objModel_ui();
		listBox_resize();
	});

	// 2021.01.18 PJTPROCOM-3 START
	var $reviewBtn = $(document).find('[data-review-event-click]');
	var chkCnt = 0;
	$reviewBtn.on('click', function(e) {
		var $obj = null;
		$obj = $(this);
		var productId = $obj.attr('data-review-model-id');
		var model = $obj.attr('data-review-model-id');
		var eventType = $obj.attr('data-review-event-click');
		var model_id = $('#modelIdH').val();
		
		if (eventType == 'BV') {
			if(chkCnt == 0){
				$BV.configure( 'global' , { 
					events : {
						submissionSubmitted : function () {
							var model_id = $('#modelIdH').val();
							var $adobeobj = $(document).find('li [data-review-model-id="' + model_id + '"]').closest('li');
							adobeTrackEvent('promotion_plp_review_bv_sumit', {
								bu: $adobeobj.attr('data-adobe-bu'),
								category: $adobeobj.attr('data-adobe-category'),
								super_category: $adobeobj.attr('data-adobe-super-category'),
								sales_model_code: $adobeobj.attr('data-adobe-salesmodelcode'),
								component: $adobeobj.attr('data-adobe-component'),
								promotion_id: $adobeobj.attr('data-adobe-promotion-id'),
								page_event: 'promotion_plp_review_bv_sumit'
							});
						},
						submissionClose : function () {
							var model_id = $('#modelIdH').val();
							var $adobeobj = $(document).find('li [data-review-model-id="' + model_id + '"]').closest('li');
							adobeTrackEvent('promotion_plp_review_bv_cancel', {
								bu: $adobeobj.attr('data-adobe-bu'),
								category: $adobeobj.attr('data-adobe-category'),
								super_category: $adobeobj.attr('data-adobe-super-category'),
								sales_model_code: $adobeobj.attr('data-adobe-salesmodelcode'),
								component: $adobeobj.attr('data-adobe-component'),
								promotion_id: $adobeobj.attr('data-adobe-promotion-id'),
								page_event: 'promotion_plp_review_bv_cancel'
							});
						}
					} 
				});
			}
			chkCnt ++;
		}

		switch(eventType){ 
		case 'BV' :
			// BV Adobe Tracking 위한 변수 추가
			$('#modelIdH').val(model);
			$BV.ui('rr','submit_review', {productId : model});
			break;
		case 'LGCOM' :
			 writeReview.init($obj);
			break;

		case 'SP' :
			break;
		
		case 'CENEO' :
			break;

		default :
			break;
		}
	});
	
	writeReview = {
		modelId : null,
		nickName : null,
		nickNameFlag : null,
		
		init: function($obj)
		{
			this.review.reviewInit();		
			this.review.addEvent($obj);
		},
		
		review : {
			reviewInit: function(){
				if ($('input[name=agreementType]').val() == 'M') {
					/* LGEITF-376 modify */
				    if (sessionStorage.getItem('ACCESS_TOKEN').length > 1) {
				         $('.agreement-area').css('display','none');
				    }
				} else {
				    $('.check-area.agree-check.email').css('display','none');
				}

				// review title
				checkTextLength($(writeReviewForm.title), $(writeReviewForm.title).siblings('.char-count').find('.char-current'));
				// review text
				checkTextLength($(writeReviewForm.review), $(writeReviewForm.review).siblings('.char-count').find('.char-current'));
				this.initRates();
			},

			initRates: function(){
				$('.GPC0103 .field-block.rates input[type="radio"]').on({
					change: function(e){
						var $currentLi = $(e.currentTarget).closest('li'),
							$currentUl = $(e.currentTarget).closest('ul'),
							$rateArea = $(e.currentTarget).closest('.rates-area');
						$currentUl.find('li').removeClass('on');
						$currentLi.addClass('on').prevUntil().addClass('on');
						$rateArea.find('.rates-number strong').text(e.currentTarget.value);
						$(e.currentTarget).closest('.rates-area').data('selected', true);
					},
					clear: function(e){
						var $currentLi = $(e.currentTarget).closest('li'),
							$currentUl = $(e.currentTarget).closest('ul'),
							$rateArea = $(e.currentTarget).closest('.rates-area');
						$currentUl.find('li').removeClass('on');
						$rateArea.find('.rates-number strong').text(0);
						writeReviewForm.rating.value = 0;
						$(e.currentTarget).closest('.rates-area').data('selected', false);
					}
				});
				$('.GPC0103 .field-block.rates li').on({
					mouseenter: function(e){
						console.log($(e.currentTarget).closest('.rates-area').data('selected'));
						if($(e.currentTarget).closest('.rates-area').data('selected') != true) {
							$(e.currentTarget).siblings().removeClass('on');
							$(e.currentTarget).addClass('on').prevUntil().addClass('on');
						}
					},
					mouseleave: function(e){
						if($(e.currentTarget).closest('.rates-area').data('selected') != true) {
							$(e.currentTarget).removeClass('on').siblings().removeClass('on');
						}
					}
				});
			},

			addEvent: function($obj){
				// write review button event
				var modelId = $obj.attr('data-review-model-id');						
				var loginUseFlag = $('#reviewDefaultData').attr('data-login-use-flag');
				var reviewLoginUrl = $obj.attr('data-review-login-url');
				var guestCheck = sessionStorage.getItem('isGuestLogined');
				$('#writeReviewForm input[name=modelId]').val(modelId);
				var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
				var url = $obj.attr('data-check');
				//PJTGADL-2
				var superCategory = $obj.attr('data-super-category-name');
				var category = $obj.attr('data-category-name');
				var subcategory = $obj.attr('data-sub-category-name');
				var modelYear = $obj.attr('data-model-year');
				var modelName = $obj.attr('data-model-name');
				var salesModelCode = $obj.attr('data-model-salesmodelcode');
				var sku = $obj.attr('data-sku');
				var suffix = $obj.attr('data-model-suffixcode');
				var bu = $obj.attr('data-bu');
	
				// rating
				var previewRating = $('[data-review-model-id='+modelId+']').attr('data-review-participantCount');
				var previewRatingPercent = $('[data-review-model-id='+modelId+']').attr('data-review-starRatingPercent');
				var pReviewRatingStar = $('[data-review-model-id='+modelId+']').attr('data-review-starRatingValue');
				
				
				if(token) {
					writeReviewForm.accessToken.value = token;
				}

				if(loginUseFlag == "N") {
					ajax.noCacheCall(url, 'modelId='+modelId, 'json', function (data) {
						if(data.data[0].isFakeReview == 'Y') {
							$('#modal_duplicate_error').modal('show');
						} else {
							$('.review-view-area .number').find('strong').text(pReviewRatingStar);
							$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
							$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
							//PJTGADL-2
							$('#writeReviewForm').attr('data-super-category-name',superCategory);
							$('#writeReviewForm').attr('data-category-name',category);
							$('#writeReviewForm').attr('data-sub-category-name',subcategory);
							$('#writeReviewForm').attr('data-model-year',modelYear);
							$('#writeReviewForm').attr('data-model-name',modelName);
							$('#writeReviewForm').attr('data-model-salesmodelcode',salesModelCode);
							$('#writeReviewForm').attr('data-sku',sku);
							$('#writeReviewForm').attr('data-model-suffixcode',suffix);
							$('#writeReviewForm').attr('data-bu',bu);
							$('#writeReviewForm').attr('data-model-id',modelId);
							//PJTGADL-2
							$('#modal-inhouseReview').modal('show');
						}
					}, 'post');	
				} else {
					if(token && url){
						ajax.noCacheCall(url, 'modelId='+modelId, 'json', function (data) {
							if(data.data[0].loginCheck == true) {
								if(data.data[0].isWritable == 0) {
									// member & duplicate
									$('#modal_duplicate_error').modal('show');
								} else {
									// member & is-writable
									$('.GPC0103 .guest-area').remove();
									if(COUNTRY_CODE == 'it') $('.GPC0103 .agreement-area').remove();
									$('.review-view-area .number').find('strong').text(pReviewRatingStar);
									$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
									$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
									//PJTGADL-2
									$('#writeReviewForm').attr('data-super-category-name',superCategory);
									$('#writeReviewForm').attr('data-category-name',category);
									$('#writeReviewForm').attr('data-sub-category-name',subcategory);
									$('#writeReviewForm').attr('data-model-year',modelYear);
									$('#writeReviewForm').attr('data-model-name',modelName);
									$('#writeReviewForm').attr('data-model-salesmodelcode',salesModelCode);
									$('#writeReviewForm').attr('data-sku',sku);
									$('#writeReviewForm').attr('data-model-suffixcode',suffix);
									$('#writeReviewForm').attr('data-bu',bu);
									$('#writeReviewForm').attr('data-model-id',modelId);
									//PJTGADL-2
									$('#modal-inhouseReview').modal('show');
									
									if(data.data[0].nickNameFlag == 'Y'){
										if(!(!!data.data[0].nickName)){
											$('#modal_nickname_edit').modal('show');
											writeReview.nickName = data.data[0].nickName;
											writeReview.nickNameFlag = data.data[0].nickNameFlag;
										}else{
											writeReview.nickName = data.data[0].nickName;
											writeReview.nickNameFlag = data.data[0].nickNameFlag;
										}
									}
								}
							} else {
								// guest
								$('.review-view-area .number').find('strong').text(pReviewRatingStar);
								$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
								$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
								//PJTGADL-2
								$('#writeReviewForm').attr('data-super-category-name',superCategory);
								$('#writeReviewForm').attr('data-category-name',category);
								$('#writeReviewForm').attr('data-sub-category-name',subcategory);
								$('#writeReviewForm').attr('data-model-year',modelYear);
								$('#writeReviewForm').attr('data-model-name',modelName);
								$('#writeReviewForm').attr('data-model-salesmodelcode',salesModelCode);
								$('#writeReviewForm').attr('data-sku',sku);
								$('#writeReviewForm').attr('data-model-suffixcode',suffix);
								$('#writeReviewForm').attr('data-bu',bu);
								$('#writeReviewForm').attr('data-model-id',modelId);
								//PJTGADL-2
								$('#modal-inhouseReview').modal('show');
							}
						}, 'post');
					} else {
						ajax.noCacheCall(url, 'modelId='+modelId, 'json', function (data) {
							if(data.data[0].isFakeReview == 'Y') {
								// guest & duplicate
								$('#modal_duplicate_error').modal('show');
							} else {
								if(guestCheck != null && guestCheck != '') {
									$('.review-view-area .number').find('strong').text(pReviewRatingStar);
									$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
									$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
									//PJTGADL-2
									$('#writeReviewForm').attr('data-super-category-name',superCategory);
									$('#writeReviewForm').attr('data-category-name',category);
									$('#writeReviewForm').attr('data-sub-category-name',subcategory);
									$('#writeReviewForm').attr('data-model-year',modelYear);
									$('#writeReviewForm').attr('data-model-name',modelName);
									$('#writeReviewForm').attr('data-model-salesmodelcode',salesModelCode);
									$('#writeReviewForm').attr('data-sku',sku);
									$('#writeReviewForm').attr('data-model-suffixcode',suffix);
									$('#writeReviewForm').attr('data-bu',bu);
									$('#writeReviewForm').attr('data-model-id',modelId);
									//PJTGADL-2
									$('#modal-inhouseReview').modal('show');
								} else {
									// guest
									sessionStorage.setItem('modelId',modelId);
									window.location.href = reviewLoginUrl;
								}
							}
						}, 'post');
					}
				}
			}
		}
	}

	var checkReview = {
			init : function(){
				var paramObj = getQueryStringObject();
				var modelId  = sessionStorage.getItem('modelId');
				var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
				var guestYn = paramObj.guest;
				var url = $('#reviewDefaultData').attr('data-check');
				
				if(typeof modelId != 'undefined'){
					var guestCheck = sessionStorage.getItem('isGuestLogined');
					var previewRating = $('[data-review-model-id='+modelId+']').attr('data-review-participantCount');
					var previewRatingPercent = $('[data-review-model-id='+modelId+']').attr('data-review-starRatingPercent');
					var pReviewRatingStar = $('[data-review-model-id='+modelId+']').attr('data-review-starRatingValue');

					if(guestYn == 'Y'){
						if(guestCheck == null){
							writeReview.review.reviewInit();
							$('#writeReviewForm input[name=modelId]').val(modelId);
							$('#modal-inhouseReview').data(modelId);
							$('#modal-inhouseReview').modal('show');
							$('.review-view-area .number').find('strong').text(pReviewRatingStar);
							$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
							$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
							history.pushState(null, null, window.location.href.replace('?guest=Y', ''));
						}
						if (window.sessionStorage) {
			                sessionStorage.setItem('isGuestLogined', 'Y');
			            }
					}else{
						if(modelId != null && modelId != '') {
							if(token && url){
								ajax.noCacheCall(url, 'modelId='+modelId, 'json', function (data) {
									if(data.data[0].loginCheck == true) {
										if(data.data[0].isWritable == 0) {
											// member & duplicate
											$('#modal_duplicate_error').modal('show');
										} else {
											// member & is-writable
											$('.GPC0103 .guest-area').remove();
											if(COUNTRY_CODE == 'it') $('.GPC0103 .agreement-area').remove();
											writeReview.review.reviewInit();
											$('#writeReviewForm input[name=modelId]').val(modelId);
											$('#modal-inhouseReview').data(modelId);
											$('#modal-inhouseReview').modal('show');
											$('.review-view-area .number').find('strong').text(pReviewRatingStar);
											$('.review-view-area .ratings-area .carmine-star').css({width:previewRatingPercent + '%'});
											$('.review-view-area .ratings-area .review-number').text("(" + previewRating + ")");
											
											if(data.data[0].nickNameFlag == 'Y'){
												if(!(!!data.data[0].nickName)){
													$('#modal_nickname_edit').modal('show');
													writeReview.nickName = data.data[0].nickName;
													writeReview.nickNameFlag = data.data[0].nickNameFlag;
												}else{
													writeReview.nickName = data.data[0].nickName;
													writeReview.nickNameFlag = data.data[0].nickNameFlag;
												}
											}
										}
									}
								}, 'post');
							}
						}
					}
				}
				
				function getQueryStringObject() {
				    var a = window.location.search.substr(1).split('&');
				    if (a == "") return {};
				    var b = {};
				    for (var i = 0; i < a.length; ++i) {
				        var p = a[i].split('=', 2);
				        if (p.length == 1)
				            b[p[0]] = "";
				        else
				            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
				    }
				    return b;
				}
				
			},

			checkPasswordPattern: function(val){
				var result = false;
				if (val.length > 7) {
					var n = /^.*(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
					result = n.test(val);
				}
				return result;
			}
			
		}

	//LGEITF-376 START
	setTimeout(function() {
		checkReview.init();
	}, 100);
	//LGEITF-376 END

	// submit review
	$(writeReviewForm).on({
		submit: function(e){
			e.preventDefault();
			if($(this).checkValidation()) {
				var _this = this;
				var guestCheck = sessionStorage.getItem('isGuestLogined');
				if (writeReview.nickNameFlag == 'Y' && (writeReview.nickName == null || writeReview.nickName == undefined || writeReview.nickName == '')) {
					$('#modal_nickname_edit').modal('show');
				}else{
					if((_this.password == undefined && _this.nickname == undefined) || checkReview.checkPasswordPattern(_this.password.value)){
						ajax.noCacheCall(_this.action, xssfilter($(_this).serialize()), 'json', function(data){
							if(data.status == 'success' && data.data[0].isNicDup != "duplicate"){
								// IN-HOUSE Adobe Tracking
								var modelId = $('#writeReviewForm input[name=modelId]').val();
								var $adobeobj = $(document).find('li [data-review-model-id="' + modelId + '"]').closest('li');
								adobeTrackEvent('promotion_plp_review_inhouse_sumit ', {
									bu: $adobeobj.attr('data-adobe-bu'),
									category: $adobeobj.attr('data-adobe-category'),
									super_category: $adobeobj.attr('data-adobe-super-category'),
									sales_model_code: $adobeobj.attr('data-adobe-salesmodelcode'),
									component: $adobeobj.attr('data-adobe-component'),
									promotion_id: $adobeobj.attr('data-adobe-promotion-id'),
									page_event: 'promotion_plp_review_inhouse_sumit '
								});
								//PJTGADL-2
								var rating = writeReviewForm.rating.value
								dataLayer.push({
									'event'			: 'review_complete_click',
									'superCategory'	: $('#writeReviewForm').attr('data-super-category-name'),
									'category'		: $('#writeReviewForm').attr('data-category-name'),
									'subcategory'	: $('#writeReviewForm').attr('data-sub-category-name'),
									'modelYear'		: $('#writeReviewForm').attr('data-model-year'),
									'modelName'		: $('#writeReviewForm').attr('data-model-name'),
									'modelCode'		: $('#writeReviewForm').attr('data-model-id'),
									'salesModelCode': $('#writeReviewForm').attr('data-model-salesmodelcode'),
									'sku'			: $('#writeReviewForm').attr('data-sku'),
									'suffix'        : $('#writeReviewForm').attr('data-model-suffixcode'),
									'bu'            : $('#writeReviewForm').attr('data-bu'),
									'reviewScore'   : rating
								}); console.log('review_complete_click');
								writeReviewForm.reset();
								$(writeReviewForm.rates).trigger('clear');
								$('#writeReviewForm').find('.field-block').removeClass('error');
								$('#modal-inhouseReview').modal('hide');

							}else if(guestCheck == 'Y' && data.data[0].isNicDup == "duplicate"){
								$('#modal_duplicate_error').css('z-index','10003');
								$('#modal_duplicate_error').modal('show');
							}
						});
					}else {
						$(_this.password).closest('.field-block').addClass('error').find('.invalid').show().siblings().hide();
						$(_this.password).focus();
					}
				}
			}
		}
	});
	
	// cancel review
	$('.modal-inhouseReview-close').on('click' ,function(e){
		writeReviewForm.reset();
		$(writeReviewForm.rating).trigger('clear');
		$('#writeReviewForm').find('.field-block').removeClass('error');
		$('#modal-inhouseReview').modal('hide');
	});
	
	// close review
	$('#modal-inhouseReview .modal-close').on('click' ,function(e){
		writeReviewForm.reset();
		$(writeReviewForm.rating).trigger('clear');
		$('#writeReviewForm').find('.field-block').removeClass('error');
		$('#modal-inhouseReview').modal('hide');
	});
	
	$('#editReviewNickname').on({
		submit: function(e){
			e.preventDefault();
			if($(this).checkValidation()) {
				var fNickName =  $("#nickName").val();
				ajax.noCacheCall($(this).data('ajax-url'), xssfilter($(this).serialize()), 'json', function (data) {
					if(data.status == 'success'){
						$('#modal_nickname_edit').modal('hide');
						writeReview.nickName = fNickName;
						writeReview.nickNameFlag = 'Y';
						if(!!$('#editReviewNickname').length){
							$('input[name=frmNickname]').val(fNickName);
						}
						editReviewNickname.reset();
						$('input[name=frmNickname]').val('');
						$('#nickName').val('');
					}else{
						console.log(data.status);
					}								
				}, 'post');
			}
		}					
	});

	$('#modal_nickname_edit .modal-nick-close').on('click' ,function(e){
		$('#modal_nickname_edit').modal('hide');
		editReviewNickname.reset();
	});
	// 2021.01.18 PJTPROCOM-3 END
	
	const priceSyncGPC0026 = {
		el: $obj,
		priceTemplate: null,
		categoryFilterForm: $('#categoryFilterForm'),
		init: function(){
			const _this = this;
			
			_this.priceTemplate = $('#priceTemplateGPC0026').clone().html();
			$('#priceTemplateGPC0026').remove();
			_this.getPrice();
		},
		getPrice: function(){
			const _this = this,
				url = _this.categoryFilterForm.data('price-sync-url'),
				param = {
					bizType: _this.categoryFilterForm.find('[name="bizType"]').val(),
					promotionId: _this.categoryFilterForm.find('[name="promotionId"]').val()
				};
				
			ajax.call(url, param, 'json', function(data){
				if(data.status == 'success' && data.data){
					const responseData = data.data[0];
					const multiCategorys = responseData.multiCategorys;
					const productMessages = responseData.productMessages;
					
					let commonData = {};
					commonData.outOfStockText = productMessages.outOfStockText;
					commonData.limitSaleSoldOutText = productMessages.limitSaleSoldOutText;
					commonData.limitSaleTitle = productMessages.limitSaleTitle;
					commonData.reStockFuncFlag = responseData.reStockFuncFlag;
					commonData.limitSaleUseFlag = responseData.limitSaleUseFlag;
					commonData.obsInstallmentPriceDisableLink = responseData.obsInstallmentPriceDisableLink;	// LGETW-651 add
					commonData.hiddenModelShowFlag = responseData.hiddenModelShowFlag;	// LGESE-216 : Hidden 제품 노출 플래그 추가 (Default : N)
					if(!!commonData.obsInstallmentPriceDisableLink && commonData.obsInstallmentPriceDisableLink == 'Y') $obj.find('.price-installment').addClass('no-link').attr('tabindex','-1');	// LGETW-651 add
					/* LGCOMPA-44 start */
					if(!!responseData.guestPriceMessageUseFlag && responseData.guestPriceMessageUseFlag == 'Y'){
						commonData.guestPriceMessageUseFlag = responseData.guestPriceMessageUseFlag;
						commonData.guestPriceMessage = responseData.guestPriceMessage;
					}
					/* LGCOMPA-44 end */
					
					for(var i=0; i<multiCategorys.length; i++){
					//for (var category of multiCategorys) {
						const categoryList = multiCategorys[i];
						const responseCategoryId = categoryList.categoryId;
						const productList = categoryList.productList;
						
						const $targetSelector = $obj.find('.product-list-box.promotion-box').find('.promotion-list-box[categoryid='+responseCategoryId+']');
						
						for (var j=0; j<productList.length; j++) {
						//for (var p of productList) {
							const p = productList[j];
							const priceSyncHtml = priceSyncGPC0026.priceTemplate;
							
							if (priceSyncHtml) {
								const $template = _this.makePriceSyncHtml(p, commonData, priceSyncHtml);
								const scop = $targetSelector.find('li').find('.products-info[data-model-id='+p.modelId+']');
								scop.find('.model-buy').prepend($template);
								//scop.find('.price-vip-Installment, .price-area, .member-text').remove();
								//scop.find('.model-buy').append($template);
							}
						}
					}
					
					//$obj.find('.products-info .model-buy').find('.price-vip-Installment, .price-area.total, .member-text, .stock-area').removeClass('d-none');
				}
			});
		},
		makePriceSyncHtml : function(p, commonData, template){
			if (template) {
				const emiMsgFlag = !!p.obsEmiMsgFlag && p.obsEmiMsgFlag == 'Y',
					afterPay = p.afterPay,
					obsMembershipLinkTarget = commonData.obsMembershipLinkTarget,
					obsMembershipLinkUrl = commonData.obsMembershipLinkUrl,
					reStockFuncFlag = commonData.reStockFuncFlag,
					reStockAlertFlag = !!p.reStockAlertFlag && p.reStockAlertFlag == 'Y',
					rPrice = p.rPrice,
					rPriceCent = p.rPriceCent,
					rPromoPrice = p.rPromoPrice,
					rPromoPriceCent = p.rPromoPriceCent,
					discountMsg = p.discountMsg,
					bizType = p.bizType,
					obsInventoryFlag = !!p.obsInventoryFlag && p.obsInventoryFlag == 'Y',
					limitSaleUseFlag = !!p.limitSaleUseFlag && p.limitSaleUseFlag == 'Y',
					obsLimitSale = !!p.obsLimitSale && p.obsLimitSale == 'Y',
					limitSaleAreaYn = !!p.limitSaleAreaYn && p.limitSaleAreaYn == 'Y',
					obsLoginFlag = !!p.obsLoginFlag && p.obsLoginFlag ? 'Y' : 'N',
					modelStatusCode = p.modelStatusCode,
					title = obsMembershipLinkTarget == '_blank' ? $obj.find('input#openTarget').val() : '',
					stockAreaIcon = (limitSaleUseFlag && obsLimitSale && obsInventoryFlag) || reStockAlertFlag ?  $obj.find('input#outOfStockIcon').val() : '',
					isOutOfStock = (reStockAlertFlag || (limitSaleUseFlag && obsLimitSale)) ? 'out-of-stock' : '',
					hiddenModelShowFlag = commonData.hiddenModelShowFlag ; // LGESE-216
					
				let priceType,
					tempPrice = '',
					tempPromoPrice = '',
					tempLegal = ''
					obsMemberShipLinkStartHtml = '',
					obsMemberShipLinkEndHtml = '',
					stockAreaFlag = false, // LGECZ-441
					stockAreaHtml = '',
					soldOutText = '';
				
				if (p.retailerPricingFlag == 'Y') {
					priceType = 'type-text';
				} else if (!!rPromoPrice) {
					priceType = 'type-promotion';
				//LGEGMC-4258 start
				} else if (!!rPrice) {
					if(p.bizType=="B2B") {
						priceType = 'type-msrp';
					} else {
						priceType = 'type-default';
					}
				//LGEGMC-4258 end
				} else {
					priceType = 'type-none';
				}
				
				if (!!obsMembershipLinkUrl && p.membershipDisplayFlag == 'Y') {
					obsMemberShipLinkStartHtml = "<a href='"+ obsMembershipLinkUrl +"' target='"+ obsMembershipLinkTarget +"' title='" +title+ "'>";
					obsMemberShipLinkEndHtml = "</a>";
				}
				
				if (limitSaleUseFlag && obsLimitSale && !obsInventoryFlag) {
					soldOutText = commonData.limitSaleSoldOutText;
				} else if (reStockAlertFlag) {
					soldOutText = commonData.outOfStockText;
				}
				// LGECZ-441 Start
				if (( reStockFuncFlag == 'Y' || (limitSaleUseFlag && limitSaleAreaYn) ) && soldOutText != '') { 
					stockAreaFlag = true;
					stockAreaHtml = '<div class="stock-area ' + isOutOfStock +'">'
									+ stockAreaIcon
									+ '<span class="text">' + soldOutText + '</span>'
									+ '</div>';
				}
				// LGECZ-441 End
				
				// LGCOMPL-46 Start
				var currencyPosition = $('.GPC0026').find('input[name=currencyPosition]').val()
				var currencySymbol = $('.GPC0026').find('input[name=currencySymbol]').val()
				var obsConvertSubscriptionMonthlyCostArea = '';
				var obsConvertSubscriptionMonthlyCost = changeFormatFullPrice(p.obsConvertSubscriptionMonthlyCost, p.obsConvertSubscriptionMonthlyCostCent)
				if(p.obsConvertSubscriptionMonthlyCost != null && obsConvertSubscriptionMonthlyCost != '0') {
					if(currencyPosition != null) {
						obsConvertSubscriptionMonthlyCostArea = currencyPosition == 'R' ? obsConvertSubscriptionMonthlyCost + "" + currencySymbol
															:	currencyPosition == 'L' ? currencySymbol + "" + obsConvertSubscriptionMonthlyCost
															: '';
						}
				}
				// LGCOMPL-46 End

				//LGCOMIS-121
				if(COUNTRY_CODE.toLowerCase() == 'it'){
					commonData.limitSaleTitle = '';
				}
				
				template = template.replace(/\*modelId\*/g, p.modelId)
				.replace(/\*retailerPricingText\*/g, !!p.retailerPricingText ? p.retailerPricingText : '')
				.replace(/\*emiPopUrl\*/g, !!commonData.emiPopupUrl ? commonData.emiPopupUrl : '')
				.replace(/\*emiMsg\*/g, emiMsgFlag ? p.emiMsg : '')
				.replace(/\*display\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 3000) ? '' : 'style="display:none;"')
				.replace(/\*zipdisplay\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 10000) ? '' : 'style="display:none;"') /* OBSLGEAU-749 (5000 -> 10000) */
				.replace(/\*orZipPay\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 3000) ? 'or ' : '')
				.replace(/\*zipPayInstallMent\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;') /* OBSLGEAU-749 (5000 -> 10000) */
				.replace(/\*afterPayInstallMent\*/g, emiMsgFlag && !!p.emiMsg && (afterPay <= 3000 && afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')
				.replace(/\*msrp\*/g, nvl(p.msrp,'0'))
				.replace(/\*obsMembershipLinkUrl\*/g, obsMembershipLinkUrl)
				.replace(/\*membershipDisplayFlag\*/g, p.membershipDisplayFlag)
				.replace(/\*stockArea\*/g, stockAreaFlag ? stockAreaHtml : '') // LGECZ-441
				.replace(/\*limitSaleTitle\*/g, commonData.limitSaleTitle)
				.replace(/\*promotionText\*/g, !!p.promotionText ? p.promotionText : '')
				.replace(/\*obsMembershipLinkTarget\*/g, !!obsMembershipLinkTarget ? obsMembershipLinkTarget : '')
				.replace(/\*membershipPrice\*/g, !!p.rMembershipPriceCent ? changeFormatFullPriceSync(p.rMembershipPrice, p.rMembershipPriceCent) : (!!p.rMembershipPrice ? changeFormatPriceSync(p.rMembershipPrice) : ''))
				.replace(/\*priceType\*/g, priceType)
				.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml)
				.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml)
				.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode)
				// LGCOMPL-46 Start
				.replace(/\*obsSubscriptionLandingPageUrl\*/g, p.obsSubscriptionLandingPageUrl != null ? p.obsSubscriptionLandingPageUrl : '')
				.replace(/\*obsSubscriptionCtaLinkTarget\*/g, p.obsSubscriptionCtaLinkTarget != null ? p.obsSubscriptionCtaLinkTarget : '')
				.replace(/\*obsSubscriptionDisclaimer\*/g, p.obsSubscriptionDisclaimer != null ? p.obsSubscriptionDisclaimer : '')
				.replace(/\*obsConvertSubscriptionMonthlyCostArea\*/g, obsConvertSubscriptionMonthlyCostArea != '' ? obsConvertSubscriptionMonthlyCostArea : '')
				.replace(/\*obsSubscriptionMaxMonth\*/g, p.obsSubscriptionMaxMonth != null ? p.obsSubscriptionMaxMonth : '')
				// LGCOMPL-46 End
				//LGCOMITF-69 START
				.replace(/\*obsWelcomePrice\*/g, !!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag && p.obsWelcomePrice != null ? changeFormatFullPrice(p.obsWelcomePrice, p.obsWelcomePriceCent) : '')
				.replace(/\*obsWelcomePriceDescription\*/g, !!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag && p.obsWelcomePriceDescription != '' ? p.obsWelcomePriceDescription : '')
				//LGCOMITF-69 END
				;
				
				// Price
				// LGEDE-1301 modelStatusCode Hideen 가격 노출
				// LGESE-216 : Hidden 제품 노출 플래그 추가 (Default : N)
				if (modelStatusCode == 'ACTIVE' || (modelStatusCode == 'HIDDEN' && hiddenModelShowFlag == 'Y') ) {
					if (!!rPromoPriceCent) {
						tempPrice = changeFormatFullPriceSync(rPromoPrice, rPromoPriceCent);
						tempPromoPrice = changeFormatFullPriceSync(rPrice, rPriceCent);
						tempLegal = discountMsg;
					} else if (!!rPromoPrice) {
						tempPrice = changeFormatFullPriceSync(rPromoPrice);
						tempPromoPrice = changeFormatFullPriceSync(rPrice);
						tempLegal = discountMsg;
					} else if (!!rPriceCent) {
						tempPrice = changeFormatFullPriceSync(rPrice, rPriceCent);
					} else if (!!rPrice) {
						tempPrice = changeFormatFullPriceSync(rPrice);
					}
					
				}
				
				let $html = $(template);
				
				// Delete
				if (bizType == 'B2B' && obsLoginFlag == 'Y' && !!rPrice) {
					$html.find('.price-area > div.msrp').remove();
				}
				if (!!p.membershipDisplayFlag && p.membershipDisplayFlag != 'Y') {
					$html.find('.member-text').empty();
				}
				// LGCOMPL-216 Start
				if(p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice) {
					if( $html.find('.lowest-price-mark').length ) $html.find('.lowest-price-mark').removeClass('d-none');
					if( $html.find('.lowest-price').length ) $html.find('.lowest-price').removeClass('d-none');
				} else {
					if( $html.find('.lowest-price-mark').length ) $html.find('.lowest-price-mark').html('');
					if( $html.find('.lowest-price').length ) $html.find('.lowest-price').html('');
				}
				// LGCOMPL-216 End
				
				//LGCOMITF-69 START
				if(!!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag && p.obsWelcomePriceDescription != ''){
					$html.find('.coupon-price').removeClass('d-none');
				}else{
					$html.find('.coupon-price').html('');
				}
				//LGCOMITF-69 END
				
				if (!!!rPrice || !!!rPromoPrice) {
					$html.find('.recommended-retail-price').remove();
				}
				// LGEDE-1301 modelStatusCode Hideen 가격 노출
				if ( !(modelStatusCode == 'HIDDEN' && COUNTRY_CODE.toLowerCase() == 'de') && modelStatusCode != 'ACTIVE') {
					$html.find('.purchase-price, .product-price').remove();
				}
				if (!!p.retailerPricingFlag && p.retailerPricingFlag != 'Y') {
					$html.find('.price-area > div.text').remove();
				}
				if (afterPay <= 0 || p.obsInventoryFlag != 'Y') {
					$html.find('.price-vip-Installment > a.afterpay-installment').remove();
				}
				if (limitSaleUseFlag || !obsLimitSale) {
					$html.find('.price-vip').empty();
				}
				
				/* LGCOMPA-44 start */
				if(  SIGN_IN_STATUS == 'N'
				  && !!p.membershipDisplayFlag
				  &&   p.membershipDisplayFlag == 'Y'
				  && !!commonData.guestPriceMessageUseFlag
				  &&   commonData.guestPriceMessageUseFlag == 'Y'
				  && !!commonData.guestPriceMessage ){
					$html.find('.member-text').html('').append(commonData.guestPriceMessage);
				}
				/* LGCOMPA-44 end */
				
				// Setting
				// LGEDE-1301 modelStatusCode Hideen 가격 노출
				// LGESE-216 : Hidden 제품 노출 플래그 추가 (Default : N)
				if (modelStatusCode == 'ACTIVE' || (modelStatusCode == 'HIDDEN' && hiddenModelShowFlag == 'Y') ) {
					$html.find('.purchase-price .number').text(tempPrice);
					$html.find('.product-price .number').text(tempPromoPrice);
					$html.find('.product-price .legal').html(!!tempLegal ? tempLegal.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>') : '');
				}
				if (limitSaleUseFlag && obsLimitSale) {
					$html.find('.price-vip-Installment .price-vip').text(commonData.limitSaleTitle); // LGEITF-805 
				}
				
				/* LGETW-651 start */
				if(!!commonData.obsInstallmentPriceDisableLink && commonData.obsInstallmentPriceDisableLink == 'Y'){
					$html.find('.price-installment').addClass('no-link').attr('tabindex','-1');
				}
				/* LGETW-651 end */
				
				//LGCOMPL-46
				if(p.obsSubscriptionEnableFlag != null && p.obsSubscriptionEnableFlag == 'Y') {
					$html.find('.button a.subscribe-box').removeClass('d-none');
				}
				//LGCOMPL-46

				return $html.html();
			}
		}
	}
	
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === 'data-is-vip') {
				priceSyncSet(mutation.target.getAttribute('data-is-vip'));
				observer.disconnect();
			}
		});
	});
	observer.observe($target, {
		attributes: true, childList: false, characterData: false
	});
	
	if($obj.attr('data-is-vip') != 'NULL'){
		priceSyncSet($obj.attr('data-is-vip'));
		observer.disconnect();
	}
	
	function priceSyncSet(flag){
		if(flag == 'false'){
			priceSyncGPC0026.init();
		}else{
			priceSyncGPC0026.el.find('.products-info .model-buy').find('.member-text.d-none').removeClass('d-none');
			priceSyncGPC0026.el.find('.products-info .model-buy').find('.stock-area.d-none').removeClass('d-none');
			priceSyncGPC0026.el.find('.products-info .model-buy').find('.price-area.total.d-none').removeClass('d-none');
			priceSyncGPC0026.el.find('.products-info .model-buy').find('.price-vip-Installment').removeClass('d-none');
		}
	}
});